module.exports = __webpack_public_path__ + "static/BrushStrokeLeft-b7b9dbfb014d3f2143b1020be467680b.png";